import { Expose, Type } from 'class-transformer';

import { SnBaseLayer } from './base-layer';
import { SnLayerMeta } from './layer-meta';
import { SnLayerType } from './layer-type';

export class InternalGeoJSONLayerMeta extends SnLayerMeta {}

export class SnInternalGeoJSONLayer extends SnBaseLayer {
  @Expose({ name: 'fileGeojson' })
  public fileGeojson: string;

  @Expose()
  @Type(() => InternalGeoJSONLayerMeta)
  public meta: InternalGeoJSONLayerMeta;

  public readonly type = SnLayerType.InternalGeoJSON;
}
